export function round(num: number| undefined): number {
    if(num === undefined)
        return 0
    return +(Math.round(Number(num + "e+2"))  + "e-2");
}
